module.exports = __webpack_public_path__ + "media/content-creator/mobile-travel-1-30677a46.png";